/* eslint 'no-useless-concat' :'off',eqeqeq : 'off'  */
import * as types from '../action/actionTypes';
import * as url from '../api/url';
import APIutil from '../api/APIutils';
import {global_error_handling} from './GlobalErrorMgmtAction';
import { setAmplitudeEvent } from 'amplitude/amplitude';


export function  GetWorkorderList(){
    return function(dispatch){
        return APIutil.getDataAPI(url.get_WorkorderList).then(response => {
            dispatch(global_error_handling(response));
            if(response!=null && response!=undefined)
                dispatch(actionToStoreSuccess(response,types.GET_WORKORDERLIST));
        }).catch(error =>{
            throw error;
        })
    }
}

export function GetClosedWorkorderList(){
    return function(dispatch){
        return APIutil.getDataAPI(url.get_ClosedWorkorderList).then(response => {
            dispatch(global_error_handling(response));
            if(response!==null && response!==undefined)
                dispatch(actionToStoreSuccess(response,types.GET_CLOSEDWORKORDERLIST));
        }).catch(error => {
            throw error;
        })
    }
}

export function GetWorkorderDetails(WorkOrderId){
    return function(dispatch){
        return APIutil.getDataAPI(url.get_WorkorderList+'/'+WorkOrderId).then(response => {
            dispatch(global_error_handling(response));
            if(response!=null && response!=undefined)
                dispatch(actionToStoreSuccess(response,types.GET_WORKORDERDETAILS));
        }).catch(error =>{
            throw error;
        })
    }
}

export function  GetEquipmentWorkorderList(id){
    return function(dispatch){
        return APIutil.getDataAPI(url.get_Equipment_WorkorderList+'/'+id).then(response => {
            dispatch(global_error_handling(response));
            if(response!=null && response!=undefined)
                dispatch(actionToStoreSuccess(response,types.GET_WORKORDERLIST));
        }).catch(error =>{
            throw error;
        })
    }
}

export function GetWorkOrderBuildings(){
    return function(dispatch){
        return APIutil.getDataAPI(url.get_Workorderbuildings).then(response => {
            dispatch(global_error_handling(response));
            if(response!=null && response!=undefined)
                dispatch(actionToStoreSuccess(response,types.GET_WORKORDER_BUILDINGS));
        }).catch(error => {
            throw error;
        })
    }
}

export function GetWorkOrderBuilding(Id){
    return function(dispatch){
        return APIutil.getDataAPI(url.get_Workorderbuildings+'/'+Id).then(response => {
            dispatch(global_error_handling(response));
            if(response!=null && response!=undefined)
                dispatch(actionToStoreSuccess(response,types.GET_WORKORDER_BUILDING));
        }).catch(error => {
            throw error;
        })
    }
}

export function GetWorkOrderBuildingsEquipments(BuildingId){
    return function(dispatch){
        let buildingEquipmentUrl = BuildingId > 0 ? 'api/buildings/' + BuildingId + '/equipment' : url.get_WorkorderbuildingsEquipments;
        return APIutil.getDataAPI(buildingEquipmentUrl).then(response => {
            dispatch(global_error_handling(response));
            if(response!=null && response!=undefined)
                dispatch(actionToStoreSuccess(response,types.GET_WORKORDER_BUILDINGS_EQUIPMENTS));
        }).catch(error => {
            throw error;
        })
    }
}

export function GetPMBuildingsEquipments(BuildingId){
    return function(dispatch){
        let buildingEquipmentUrl = BuildingId > 0 ? 'api/preventativeMaintenance/buildings/' + BuildingId + '/equipments' : url.get_PMbuildingsEquipments;
        return APIutil.getDataAPI(buildingEquipmentUrl).then(response => {
            dispatch(global_error_handling(response));
            if(response!=null && response!=undefined)
                dispatch(actionToStoreSuccess(response,types.GET_PM_BUILDINGS_EQUIPMENTS));
        }).catch(error => {
            throw error;
        })
    }
}

export function  GetWorkorderTechnician(){
    return function(dispatch){
        return APIutil.getDataAPI(url.get_Technician).then(response => {
            dispatch(global_error_handling(response));
            if(response!=null && response!=undefined)
                dispatch(actionToStoreSuccess(response,types.GET_TECHNICIANLIST));
        }).catch(error =>{
            throw error;
        })
    }
}

export function GetWorkorderTechnicianByID(TechnicianId){
    return function(dispatch){
        return APIutil.getDataAPI(url.get_Technician+ "/" + TechnicianId).then(response => {
            dispatch(global_error_handling(response));
            if(response!=null && response!=undefined)
                dispatch(actionToStoreSuccess(response,types.GET_TECHNICIANDETAILS));
        }).catch(error =>{
            throw error;
        })
    }
}

export function SaveAttachmentFromServiceRequest(file) { 
    return function (dispatch) {
        return APIutil.PostServiceReqImages(url.post_WorkOrderAttachment_Form,file).then(response => {
            dispatch(global_error_handling(response)); 
            if(response.status == 200){
                var l_FileName = response.data.l_FileNames;
                return l_FileName;
            }  
        }).catch(error => { throw error; })
    }
}



export function SaveWorkOrder(data, EquipmentId){
    return function (dispatch) {
        return APIutil.postData(url.post_WorkOrder,data).then(response => {
            dispatch(global_error_handling(response));  
            if(response.status == 200)
            {
                if(EquipmentId > 0)
                    dispatch(GetEquipmentWorkorderList(EquipmentId))
                else{
                     dispatch(GetClosedWorkorderList());
                     dispatch(GetWorkorderList());                    
                }
            }
        }).catch(error => { throw error; })
    }
}

export function UpdateWorkOrder(data, id){
    return function (dispatch) {
        return APIutil.editDataAPI(url.post_WorkOrder+"/"+id,data).then(response => {
            dispatch(global_error_handling(response));  
            if(response.status == 200)
            {
                if(data.EquipmentSummaryID  > 0)
                    dispatch(GetEquipmentWorkorderList(data.EquipmentSummaryID))
                else{
                    dispatch(GetClosedWorkorderList());
                    dispatch(GetWorkorderList());   
                }
            }    
        }).catch(error => { throw error; })
    }
}

export function AddWorkOrderAttachments(data,id){
    return function (dispatch) {
        return APIutil.postData(url.post_WorkOrder+"/"+id+"/attachments",data).then(response => {
            dispatch(global_error_handling(response));  
            if(response.status == 200)
                dispatch(GetWorkorderDetails(id));
        }).catch(error => { throw error; })
    }
}

export function DeleteWorkOrderAttachment(WOID,id){
    return function (dispatch) {
        return APIutil.deleteAPI(url.delete_Workorder +"/" + WOID+"/attachments/"+id).then(response => {
            dispatch(global_error_handling(response)); 
            if(response.status == 200)
                dispatch(GetWorkorderDetails(WOID));
        }).catch(error => { throw error; })
    }
}

export function PostAttachment(file) { 

    return function (dispatch) {
        return APIutil.postImage(url.post_WorkOrderAttachment,file).then(response => {
            dispatch(global_error_handling(response)); 
        }).catch(error => { throw error; })
    }
}

export function SaveAttachmentToFolder(file, AttachmentId) { 
    return function (dispatch) {
        return APIutil.postImage(url.post_WorkOrderAttachmentToFolder,file).then(response => {
            dispatch(global_error_handling(response)); 
            if(response != null && response != undefined){
                var AttachmentData = { 'Id' : AttachmentId, 'FileName' : response.data.l_FileName }
                dispatch(actionToStoreSuccess(AttachmentData,types.GET_UNIQUEFILENAME));
            }
        }).catch(error => { throw error; })
    }
}

export function SaveAsAttachment(data){
    return function (dispatch) {
        return APIutil.postData(url.Copy_Attachments,data).then(response => {
            dispatch(global_error_handling(response)); 
            if(response != null && response != undefined){
                dispatch(actionToStoreSuccess(response.data,types.GET_UNIQUEFILECOLLECTION));
            }
        }).catch(error => { throw error; })
    }
}

export function DeleteAttachment(data){
    return function (dispatch) {
        return APIutil.deleteDataAPI(url.post_WorkOrderAttachment,data).then(response => {
            dispatch(global_error_handling(response)); 
        }).catch(error => { throw error; })
    }
}

export function SaveComments(data){
    return function (dispatch){
        return APIutil.postData(url.post_WorkOrder+'/'+data.WorkOrderID + '/comments',data).then(response => {
            dispatch(global_error_handling(response));  
            if(response.status == 200)
                dispatch(GetWorkorderDetails(data.WorkOrderID));
        }).catch(error => { throw error; })
    }
}

export function SavePMComments(data){
    return function (dispatch){
        return APIutil.postData(url.post_PreventativeMaintenances+'/'+data.PMId + '/comments',data).then(response => {
            dispatch(global_error_handling(response));  
            if(response.status == 200)
                dispatch(GetPreventativeMaintenanceDetails(data.PMId));
        }).catch(error => { throw error; })
    }
}

export function UpdateComments(data){
    return function (dispatch){
        return APIutil.editDataAPI(url.post_WorkOrder+'/'+data.WorkOrderID + '/comments/'+data.workOrderCommentID,data).then(response => {
            dispatch(global_error_handling(response));  
            if(response.status == 200)
                dispatch(GetWorkorderDetails(data.WorkOrderID));
        }).catch(error => { throw error; })
    }
}


export function UpdatePMComments(data){
    return function (dispatch){
        return APIutil.editDataAPI(url.post_PreventativeMaintenances+'/'+data.PMId + '/comments/'+data.CommentID,data).then(response => {
            dispatch(global_error_handling(response));  
            if(response.status == 200)
                dispatch(GetPreventativeMaintenanceDetails(data.PMId));
        }).catch(error => { throw error; })
    }
}

export function DeleteComments(data){
    return function (dispatch){
        return APIutil.deleteDataAPI(url.post_WorkOrder+'/'+data.WorkOrderID + '/comments/'+data.commentId).then(response => {
            dispatch(global_error_handling(response));  
            if(response.status == 200)
                dispatch(GetWorkorderDetails(data.WorkOrderID));
        }).catch(error => { throw error; })
    }
}

export function DeletePMComments(data){
    return function (dispatch){
        return APIutil.deleteDataAPI(url.post_PreventativeMaintenances+'/'+data.PMId + '/comments/'+data.commentId).then(response => {
            dispatch(global_error_handling(response));  
            if(response.status == 200)
                dispatch(GetPreventativeMaintenanceDetails(data.PMId));
        }).catch(error => { throw error; })
    }
}

export function DownloadAttachment(data) { 
    return function (dispatch) {
        return APIutil.getPDFDataAPI(url.download_Attachmnet+"/"+data).then(response => {

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                console.log("IE Browser");
                window.navigator.msSaveOrOpenBlob(new Blob([response]), data);
            }
            else {
            const url = window.URL.createObjectURL(new Blob([response]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', data);
            document.body.appendChild(link);
            link.click();
            }
                //dispatch(actionToStoreSuccess(response,types.DOWNLOAD_INVOICE_SUCCESSFUL));
        }).catch(error => { throw error; })
    }
}

export function PostParts(data){
    return function (dispatch){
        return APIutil.postData(url.post_WorkOrder+'/'+data.WorkOrderID + '/parts',data).then(response => {
            dispatch(global_error_handling(response));  
            if(response.status == 200)
                dispatch(GetWorkorderDetails(data.WorkOrderID));
        }).catch(error => { throw error; })
    }
}

export function PostPMParts(data){
    return function (dispatch){
        return APIutil.postData(url.post_PreventativeMaintenances+'/'+data.PMId + '/parts',data).then(response => {
            dispatch(global_error_handling(response));  
            if(response.status == 200)
                dispatch(GetPreventativeMaintenanceDetails(data.PMId));
        }).catch(error => { throw error; })
    }
}

export function DeleteWorkorderParts(data){
    return function (dispatch) {
        return APIutil.deleteDataAPI(url.post_WorkOrder+'/'+data.workOrderID + '/parts/' + data.partId,data).then(response => {
            dispatch(global_error_handling(response));
            if(response.status == 200)
            dispatch(GetWorkorderDetails(data.workOrderID));
        }).catch(error => { throw error; })  
    }
} 

export function DeletePMParts(data){
    return function (dispatch) {
        return APIutil.deleteDataAPI(url.post_PreventativeMaintenances+'/'+data.pmId + '/parts/' + data.partId,data).then(response => {
            dispatch(global_error_handling(response));
            if(response.status == 200)
            dispatch(GetPreventativeMaintenanceDetails(data.pmId));
        }).catch(error => { throw error; })  
    }
} 

export function EditParts(data,partId){
    return function (dispatch) {
        return APIutil.editDataAPI(url.post_WorkOrder+'/'+data.WorkOrderID + '/parts/' + partId,data).then(response =>{
            dispatch(global_error_handling(response));
            if(response.status == 200)
            dispatch(GetWorkorderDetails(data.WorkOrderID));  
        }).catch(error => { throw error; })
    }
}

export function EditPMParts(data,partId){
    return function (dispatch) {
        return APIutil.editDataAPI(url.post_PreventativeMaintenances+'/'+data.PMId + '/parts/' + partId,data).then(response =>{
            dispatch(global_error_handling(response));
            if(response.status == 200)
            dispatch(GetPreventativeMaintenanceDetails(data.PMId));  
        }).catch(error => { throw error; })
    }
}

export function PostLaborDetails(data){
    return function (dispatch){
        return APIutil.postData(url.post_WorkOrder+'/'+data.WorkOrderID + '/labors',data).then(response => {
            dispatch(global_error_handling(response));  
            if(response.status == 200)
                dispatch(GetWorkorderDetails(data.WorkOrderID));
        }).catch(error => { throw error; })
    }
}

export function PostPMLaborDetails(data){
    return function (dispatch){
        return APIutil.postData('api/preventativeMaintenace'+'/'+data.PMId + '/labors',data).then(response => {
            dispatch(global_error_handling(response));  
            if(response.status == 200)
                dispatch(GetPreventativeMaintenanceDetails(data.PMId));
        }).catch(error => { throw error; })
    }
}

export function EditLaborDetails(Id,data){
    return function (dispatch){
        return APIutil.editDataAPI(url.post_WorkOrder+'/'+data.WorkOrderID + '/labors/'+Id,data).then(response => {
            dispatch(global_error_handling(response));  
            if(response.status == 200)
                dispatch(GetWorkorderDetails(data.WorkOrderID));
        }).catch(error => { throw error; })
    }
}

export function EditPMLaborDetails(Id,data){
    return function (dispatch){
        return APIutil.editDataAPI(url.post_PreventativeMaintenances+'/'+data.PMId + '/labors/'+Id,data).then(response => {
            dispatch(global_error_handling(response));  
            if(response.status == 200)
                dispatch(GetPreventativeMaintenanceDetails(data.PMId));
        }).catch(error => { throw error; })
    }
}

export function DeleteLaborDetails(data){
    return function (dispatch) {
        return APIutil.deleteDataAPI(url.post_WorkOrder+'/'+data.WorkOrderID + '/labors/' + data.laborId,data).then(response => {
            dispatch(global_error_handling(response));
            if(response.status == 200)
            dispatch(GetWorkorderDetails(data.workOrderID));
        }).catch(error => { throw error; })  
    }
} 

export function DeletePMLaborDetails(data){
    return function (dispatch) {
        return APIutil.deleteDataAPI(url.post_PreventativeMaintenances+'/'+data.pmId + '/labors/' + data.laborId,data).then(response => {
            dispatch(global_error_handling(response));
            if(response.status == 200)
            dispatch(GetPreventativeMaintenanceDetails(data.pmId));
        }).catch(error => { throw error; })  
    }
} 

export function DeleteWorkOrder(data,EquipmentId){
    return function (dispatch) {
        return APIutil.deleteDataAPI(url.delete_Workorder, data).then(response => {
            dispatch(global_error_handling(response)); 
            if(response.status == 200)
            {
                if(EquipmentId > 0){
                    dispatch(GetEquipmentWorkorderList(EquipmentId));
                    dispatch(GetClosedWorkorderList());
                }
                else
                {
                    dispatch(GetClosedWorkorderList());
                    dispatch(GetWorkorderList());
                }
            }
        }).catch(error => { throw error; })
    }
}

export function SaveWorkOrderBuilding(data){
    return function (dispatch) {
        return APIutil.postData(url.post_WorkOrderBuilding,data).then(response => {
            dispatch(global_error_handling(response)); 
        }).catch(error => { throw error; })
    }
}

export function SaveWorkOrderEquipment(data){
    return function (dispatch){
        return APIutil.postData(url.post_WorkOrderEquipment,data).then(response => {
            dispatch(global_error_handling(response)); 
            if(response.status == 200)
                dispatch(GetWorkOrderEquipments());
        }).catch(error => {throw error;})
    }
}

export function GetWorkOrderEquipments(){
    return function(dispatch){
        return APIutil.getDataAPI(url.get_WorkorderEquipments).then(response => {
            dispatch(global_error_handling(response));
            if(response!=null && response!=undefined)
                dispatch(actionToStoreSuccess(response,types.GET_WORKORDER_EQUIPMENTS));
        }).catch(error => {
            throw error;
        })
    }
}

export function DeleteWorkOrderBuilding(id,data){
    return function (dispatch) {
        return APIutil.deleteDataAPI(url.post_WorkOrderBuilding +"/" + id,data).then(response => {
            dispatch(global_error_handling(response)); 
            if(response.status == 200)
                dispatch(GetWorkOrderBuildings());
        }).catch(error => { throw error; })
    }
}

export function UpdateWorkOrderBuilding(data,id){
    return function (dispatch) {
        return APIutil.editDataAPI(url.get_Workorderbuildings+"/"+id,data).then(response =>{
            dispatch(global_error_handling(response));
        }).catch(error => { throw error; })
    }
}


export function GetBuildingAssociation(TenantId){
    return function(dispatch){
        return APIutil.getDataAPI(url.put_tenantassociation+'/'+TenantId).then(response => {
            dispatch(global_error_handling(response));
            if(response!=null && response!=undefined)
                dispatch(actionToStoreSuccess(response,types.GET_TENANT_ASSOCIATION));
        }).catch(error =>{
            throw error;
        })
    }
}

export function BuildingAssociation(BuildingDetails){
    return function (dispatch) {
        return APIutil.editDataAPI(url.put_tenantassociation,BuildingDetails).then(response =>{
            dispatch(global_error_handling(response));
        }).catch(error => { throw error; })
    }
}

export function BuildingUnAssociation(BuildingDetails){
    return function (dispatch) {
        return APIutil.deleteDataAPI(url.put_tenantassociation,BuildingDetails).then(response => {
            dispatch(GetBuildingAssociation(BuildingDetails[0].tenantId));
            dispatch(global_error_handling(response)); 
        }).catch(error => { throw error; })
    }
}

export function SetTenantId (data) {
    return {
        type: types.TENANT_TO_ASSOCIATE,
        tenant_to_associate: data
    }
}

export function ChangeDisplayinWorkOrderBuilding (data,buildingId) {
    return {
        type: types.CHANGE_VIEW_WORKORDER_BUILDINGS,
        page_to_display_building: data,
        Selected_Building_Id: buildingId
    }
}

export function ChangeDisplayinWorkOrderTenant (data) {
    return {
        type: types.CHANGE_VIEW_WORKORDER_TENANTS,
        page_to_display_tenant: data
    }
}

export function GetStandardFields(){
    return function(dispatch){
        return APIutil.getDataAPI(url.get_WorkOrderStandardField).then(response => {
            dispatch(global_error_handling(response));
            if(response!=null && response!=undefined)
            {
                dispatch(actionToStoreSuccess(response,types.GET_STANDARD_FIELDS));
            }
        }).catch(error => {
            throw error;
        })
    }
}

export function RefreshStandardFields(){
    return function(dispatch){
        return APIutil.getDataAPI(url.get_WorkOrderStandardField).then(response => {
            dispatch(global_error_handling(response));
            if(response!=null && response!=undefined)
            {
                dispatch(actionToStoreSuccess(response,types.GET_STANDARD_FIELDS));
                dispatch(actionToStoreSuccess(response,types.WORKORDER_USER_PREFERENCE_SUCCESSFUL));
            }
        }).catch(error => {
            throw error;
        })
    }
}

export function RefreshPreventativeMaintenanceStandardFields(){
    return function(dispatch){
        return APIutil.getDataAPI(url.get_PrevenatativeMaintenanceStandardField).then(response => {
            dispatch(global_error_handling(response));
            if(response!=null && response!=undefined)
            {
                dispatch(actionToStoreSuccess(response,types.GET_PREVENTATIVE_MAINTENANCE_STANDARD_FIELDS));
                dispatch(actionToStoreSuccess(response,types.PREVENTATIVE_USER_PREFERENCE_SUCCESSFUL));
                //dispatch(actionToStoreSuccess(response,types.WORKORDER_USER_PREFERENCE_SUCCESSFUL));
            }
        }).catch(error => {
            throw error;
        })
    }
}

export function UpdateStandardFields(data, id){
    return function (dispatch) {
        return APIutil.editDataAPI(url.add_WorkOrderStandardField+"/"+id,data).then(response => {
            dispatch(global_error_handling(response));  
            if(response.status == 200)
                dispatch(RefreshStandardFields());
        }).catch(error => { throw error; })
    }
}

export function SaveStandardFieldsInitialSetup(data){
    return function (dispatch) {
        return APIutil.postData(url.get_WorkOrderStandardField,data).then(response => {
            dispatch(global_error_handling(response));  
            if(response.status == 200)
                dispatch(RefreshStandardFields());
        }).catch(error => { throw error; })
    }
}

export function DeleteUserAddedFields(data,id){
    return function (dispatch) {
        return APIutil.deleteDataAPI(url.add_WorkOrderStandardField +"/" + id,data).then(response => {
            dispatch(global_error_handling(response)); 
            if(response.status == 200)
                dispatch(RefreshStandardFields());
        }).catch(error => { throw error; })
    }
}

export function  GetPreventativeMaintenanceList(){
    return function(dispatch){
        return APIutil.getDataAPI(url.get_PreventativeMaintenanceList).then(response => {
            dispatch(global_error_handling(response));
            if(response!=null && response!=undefined)
                dispatch(actionToStoreSuccess(response,types.GET_PREVENTATIVEMAINTENCELIST));
        }).catch(error =>{
            throw error;
        })
    }
}

export function GetClosedPreventativeMaintenanceList(){
    return function(dispatch){
        return APIutil.getDataAPI(url.get_ClosedPreventativeMaintenanceList).then((response) => {
            dispatch(global_error_handling(response));
            if(response!=null && response!=undefined)
                dispatch(actionToStoreSuccess(response,types.GET_CLOSEDPREVENTATIVEMAINTENANCELIST));
        }).catch(error => {
            throw error;
        })
    }
}

export function  GetWorkOrderReportsList(){
    return function(dispatch){
        return APIutil.getDataAPI(url.get_AllWorkOrderReports).then(response => {
            dispatch(global_error_handling(response));
            if(response!=null && response!=undefined)
                dispatch(actionToStoreSuccess(response,types.GET_ALL_WORKORDERREPORTSLIST));
        }).catch(error =>{
            throw error;
        })
    }
}

export function GetPreventativeMaintenanceDetails(PMId){
    return function(dispatch){
        return APIutil.getDataAPI(url.get_PreventativeMaintenanceList+'/'+PMId).then(response => {
            dispatch(global_error_handling(response));
            if(response!=null && response!=undefined)
                dispatch(actionToStoreSuccess(response,types.GET_PREVENTATIVEMAINTENANCEDETAIL));
        }).catch(error =>{
            throw error;
        })
    }
}

export function  GetEquipmentPreventativeMaintenanceList(Id){
    return function(dispatch){
        return APIutil.getDataAPI(url.get_PreventativeMaintenanceList+'/Equipment/'+Id).then(response => {
            dispatch(global_error_handling(response));
            if(response!=null && response!=undefined)
                dispatch(actionToStoreSuccess(response,types.GET_PREVENTATIVEMAINTENCELIST));
        }).catch(error =>{
            throw error;
        })
    }
}

export function GetPreventativeMaintenanceStandardFields(){
    return function(dispatch){
        return APIutil.getDataAPI(url.get_PrevenatativeMaintenanceStandardField).then(response => {
            dispatch(global_error_handling(response));
            if(response!=null && response!=undefined)
            {
                dispatch(actionToStoreSuccess(response,types.GET_PREVENTATIVE_MAINTENANCE_STANDARD_FIELDS));
            }
        }).catch(error => {
            throw error;
        })
    }
}

export function SavePreventativeMaintenance(data,EquipmentId){
    return function (dispatch) {
        return APIutil.postData(url.post_PreventativeMaintenance,data).then(response => {
            dispatch(global_error_handling(response)); 
            if(response.status == 200)
            {
                if(EquipmentId > 0){
                dispatch(GetEquipmentPreventativeMaintenanceList(EquipmentId));}
                else{
                    dispatch(GetClosedPreventativeMaintenanceList());
                    dispatch(GetPreventativeMaintenanceList());
                    
                }
            } 
 

        }).catch(error => { throw error; })
    }
}

export function UpdatePreventativeMaintenance(data, id){
    return function (dispatch) {
        return APIutil.editDataAPI(url.post_PreventativeMaintenance+"/"+id,data).then(response => {
            dispatch(global_error_handling(response)); 
            if(response.status == 200){
                if(data.Status == 6){
                    const ampScheduleType = 
                    data.ScheduleType === 1 ? "Based on Calendar" : 
                    data.ScheduleType === 2 ? "Based on Usage" : 
                    "None";
                    setAmplitudeEvent('Create Preventative Maintenance', { 'PM Template': "Existing PM",'Maintenance Schedule Type': ampScheduleType, "Notify Others":data.NotifyUserIDs.length });
            }
                if(data.EquipmentSummaryID  > 0){
                    dispatch(GetEquipmentPreventativeMaintenanceList(data.EquipmentSummaryID));
                }else{
                    dispatch(GetClosedPreventativeMaintenanceList());
                    dispatch(GetPreventativeMaintenanceList());
                   
                }
            }
           
            
        }).catch(error => { throw error; })
    }
}

export function DeletePreventativeMaintenance(id,EquipmentId){
    return function (dispatch) {
        return APIutil.deleteDataAPI(url.post_PreventativeMaintenance, id).then(response => {
            dispatch(global_error_handling(response)); 
            if(response.status == 200){
                if(EquipmentId > 0){
                    dispatch(GetEquipmentPreventativeMaintenanceList(EquipmentId));
                    dispatch(GetClosedPreventativeMaintenanceList());
                }
                else{
                    dispatch(GetClosedPreventativeMaintenanceList());
                    dispatch(GetPreventativeMaintenanceList());
                }               
            }                
        }).catch(error => { throw error; })
    }
}

export function UpdatePreventativeMaintenanceState(data, id){
    return function (dispatch) {
        return APIutil.editDataAPI(url.post_PreventativeMaintenance+"/"+id+"/state",data).then(response => {
            dispatch(global_error_handling(response)); 
            if(response.status == 200){
                if(data.EquipmentSummaryID  > 0){
                    dispatch(GetEquipmentPreventativeMaintenanceList(data.EquipmentSummaryID));
                }else{
                    dispatch(GetPreventativeMaintenanceList());
                }
            }
                
        }).catch(error => { throw error; })
    }
}

export function AddPMAttachments(data,id){
    return function (dispatch) {
        return APIutil.postData(url.post_PreventativeMaintenance+"/"+id+"/attachments",data).then(response => {
            dispatch(global_error_handling(response));  
            if(response.status == 200)
                dispatch(GetPreventativeMaintenanceDetails(id));
        }).catch(error => { throw error; })
    }
}

export function DeletePMAttachment(PMID,id){
    return function (dispatch) {
        return APIutil.deleteAPI(url.post_PreventativeMaintenance +"/" + PMID+"/attachments/"+id).then(response => {
            dispatch(global_error_handling(response)); 
            if(response.status == 200)
                dispatch(GetPreventativeMaintenanceDetails(PMID));
        }).catch(error => { throw error; })
    }
}

export function PreventativeMaintenanceStandardFieldsInitialSetup(data){
    return function (dispatch) {
        return APIutil.postData(url.add_PrevenatativeMaintenanceStandardField,data).then(response => {
            dispatch(global_error_handling(response));  
            if(response.status == 200)
                dispatch(RefreshPreventativeMaintenanceStandardFields());
        }).catch(error => { throw error; })
    }
}


export function UpdatePreventativeMaintenanceStandardFields(data, id){
    return function (dispatch) {
        return APIutil.editDataAPI(url.add_PrevenatativeMaintenanceStandardField+"/"+id,data).then(response => {
            dispatch(global_error_handling(response));  
            if(response.status == 200)
                dispatch(RefreshPreventativeMaintenanceStandardFields());
        }).catch(error => { throw error; })
    }
}

export function DeleteUserAddedFieldsFromPM(data,id){
    return function (dispatch) {
        return APIutil.deleteDataAPI(url.add_PrevenatativeMaintenanceStandardField +"/" + id,data).then(response => {
            dispatch(global_error_handling(response)); 
            if(response.status == 200)
                dispatch(RefreshPreventativeMaintenanceStandardFields());
        }).catch(error => { throw error; })
    }
}

export function  GetBuildingsTimeZones(){
    return function(dispatch){
        return APIutil.getDataAPI(url.get_all_buildings_timezone).then(response => {
            dispatch(global_error_handling(response));
            if(response!=null && response!=undefined)
                dispatch(actionToStoreSuccess(response,types.GET_BUILDINGS_TIMEZONES_SUCCESSFULL));
        }).catch(error =>{
            throw error;
        })
    }
}

//Based on Usage Related Methods

export function GetWorkOrderBuildingsList(){
    return function(dispatch){
        return APIutil.getDataAPI(url.get_Workorderbuildings+'?isDetail=false').then(response => {
            dispatch(global_error_handling(response));
            if(response!=null && response!=undefined)
                dispatch(actionToStoreSuccess(response,types.GET_WORKORDER_BUILDINGS));
        }).catch(error => {
            throw error;
        })
    }
}

export function GetFamilyTypesBySiteId(buildingId){
    return function(dispatch){
        return APIutil.getDataAPI(url.delete_Workorder_Building+buildingId+'/family').then(response => {
            dispatch(global_error_handling(response));
            if(response!=null && response!=undefined)
                dispatch(actionToStoreSuccess(response,types.GET_PM_FAMILYTYPES));
        }).catch(error =>{
            throw error;
        })
    }
}

export function GetEquipmentsByFamilyType(buildingId, familyId){
    return function(dispatch){
        return APIutil.getDataAPI(url.delete_Workorder_Building+buildingId+'/family/'+familyId).then(response => {
            dispatch(global_error_handling(response));
            if(response!=null && response!=undefined)
                dispatch(actionToStoreSuccess(response,types.GET_PM_EQUIPMENTS_BY_FAMILYTYPE));
        }).catch(error =>{
            throw error;
        })
    }
}


export function GetServerTime(){
    return function(dispatch){
        return APIutil.getDataAPI(url.get_ServerTime).then(response => {
            dispatch(global_error_handling(response));
            if(response!=null && response!=undefined)
                dispatch(actionToStoreSuccess(response,types.GET_PM_SERVERTIME));
        }).catch(error =>{
            throw error;
        })
    }
}

export function GetUsageFamilyTypesBySiteId(SiteId){
    return function(dispatch){
        return APIutil.getDataAPI(url.get_Buildings_List+SiteId+'/family').then(response => {
            dispatch(global_error_handling(response));
            if(response!=null && response!=undefined)
                dispatch(actionToStoreSuccess(response,types.GET_PM_USAGE_FAMILYTYPES));
        }).catch(error =>{
            throw error;
        })
    }
}

export function GetUsageEquipmentsByFamilyType(SiteId, familyId){
    return function(dispatch){
        return APIutil.getDataAPI(url.get_Buildings_List+SiteId+'/family/'+familyId).then(response => {
            dispatch(global_error_handling(response));
            if(response!=null && response!=undefined)
                dispatch(actionToStoreSuccess(response,types.GET_PM_USAGE_EQUIPMENTS_BY_FAMILYTYPE));
        }).catch(error =>{
            throw error;
        })
    }
}

export function GetBuildingPoints(siteId){
    return function(dispatch){
        return APIutil.getDataAPI(url.get_Family_Types+siteId+'/points').then(response => {
            dispatch(global_error_handling(response));
            if(response!=null && response!=undefined)
                dispatch(actionToStoreSuccess(response,types.GET_PM_BUILDING_POINTS));
        }).catch(error =>{
            throw error;
        })
    }
}

export function GetBuildingEquipmentPoints(siteId, equipmentId){
    return function(dispatch){
        return APIutil.getDataAPI(url.get_Family_Types+siteId+'/equipment/'+equipmentId+'/points').then(response => {
            dispatch(global_error_handling(response));
            if(response!=null && response!=undefined)
                dispatch(actionToStoreSuccess(response,types.GET_PM_BUILDING_EQUIPMENT_POINTS));
        }).catch(error =>{
            throw error;
        })
    }
}


export function SaveWorkOrderTenant(data) { 
    return function (dispatch) {
        return APIutil.postData(url.post_WorkOrder_Tenant,data).then(response => {
            dispatch(global_error_handling(response));  
            if(response.status == 200)
                dispatch(actionToStoreSuccess(response,types.POST_SUCCESSFULL));
        }).catch(error => { throw error; })
    }
}

export function GetMailSetting(){
    return function(dispatch){
        return APIutil.getDataAPI(url.get_MailSetting).then(response => {
            if(response!=null && response!=undefined)
                dispatch(actionToStoreSuccess(response,types.GET_MAILSETTING));
        }).catch(error =>{
            throw error;
        })
    }
}
//Custom Fields
export function GetCustomFields(){
    return function(dispatch){
        return APIutil.getDataAPI(url.get_WorkOrderCustomFields).then(response => {
            dispatch(global_error_handling(response));
            if(response!=null && response!=undefined)
                dispatch(actionToStoreSuccess(response, types.GET_CUSTOM_FIELDS));
        }).catch( error => {
            throw error;
        })
    }
}

export function AddWorkOrderCustomField(data){
    return function(dispatch){
        return APIutil.postData(url.post_custom_Field,data).then(response => {
            dispatch(global_error_handling(response));  
            if(response.status == 200)
                dispatch(GetCustomFields());
        }).catch(error => { throw error; })
    }
}

export function UpdateWorkOrderCustomField(data,fieldId){
    return function(dispatch){
        return APIutil.editDataAPI(url.Update_Custom_Field+"/" + fieldId,data).then(response => {
            dispatch(global_error_handling(response));  
            if(response.status == 200)
                dispatch(GetCustomFields());
        }).catch(error => { throw error; })
    }
}

export function UpdatePMCustomField(data,fieldId){
    return function(dispatch){
        return APIutil.editDataAPI(url.Update_PM_Custom_Field+"/" + fieldId,data).then(response => {
            dispatch(global_error_handling(response));  
            if(response.status == 200)
                dispatch(GetPreventativeMaintenanceCustomFields());
        }).catch(error => { throw error; })
    }
}

export function DeleteCustomField(fieldId){
    return function (dispatch) {
        return APIutil.deleteAPI(url.delete_CustomField +"/" + fieldId).then(response => {
            dispatch(global_error_handling(response)); 
            if(response.status == 200)
            {                            
               dispatch(GetCustomFields());
            }
        }).catch(error => { throw error; })
    }
}

export function DeleteCustomFieldValues(data,fieldId){
    return function (dispatch) {
        return APIutil.deleteDataAPI(url.delete_CustomFieldValue +"/" + fieldId,data).then(response => {
            dispatch(global_error_handling(response)); 
            if(response.status == 200)
            {                            
               dispatch(GetCustomFields());
            }
        }).catch(error => { throw error; })
    }
}

export function DeletePMCustomFieldValues(data,fieldId){
    return function (dispatch) {
        return APIutil.deleteDataAPI(url.delete_PM_CustomFieldValue +"/" + fieldId,data).then(response => {
            dispatch(global_error_handling(response)); 
            if(response.status == 200)
            {                            
               dispatch(GetPreventativeMaintenanceCustomFields());
            }
        }).catch(error => { throw error; })
    }
}

export function DeletePMCustomField(fieldId){
    return function (dispatch) {
        return APIutil.deleteAPI(url.get_PreventativeMaintenanceCustomFields +"/" + fieldId).then(response => {
            dispatch(global_error_handling(response)); 
            if(response.status == 200)
            {                            
               dispatch(GetPreventativeMaintenanceCustomFields());
            }
        }).catch(error => { throw error; })
    }
}

export function GetPreventativeMaintenanceCustomFields(){
    return function (dispatch){
        return APIutil.getDataAPI(url.get_PreventativeMaintenanceCustomFields).then(response => {
            dispatch(global_error_handling(response));
            if(response !== null && response !== undefined)
                dispatch(actionToStoreSuccess(response,types.GET_PM_CUSTOM_FIELDS))
        }).catch (error => {throw error;})
    }
}

export function GetPreventativeMaintenanceTemplates(){
    return function (dispatch){
        return APIutil.getDataAPI(url.get_PreventativeMaintenanceTemplates).then(response => {
            dispatch(global_error_handling(response));
            if(response !== null && response !== undefined)
                dispatch(actionToStoreSuccess(response,types.GET_PM_TEMPLATES))
        }).catch (error => {throw error;})
    }
}



export function AddPreventativeMaintenanceCustomField(data){
    return function (dispatch) {
        return APIutil.postData(url.post_PreventativeMaintenanceCustomFields,data).then(response => {
            dispatch(global_error_handling(response));
            if(response.status == 200)
                dispatch(GetPreventativeMaintenanceCustomFields());
        }).catch(error => {throw error;})
    }
}

export function UpdateCustomFieldsOrder(data){
    return function(dispatch){
        return APIutil.editDataAPI(url.Update_Custom_Field,data).then(response => {
            dispatch(global_error_handling(response));  
            if(response.status == 200)
                dispatch(GetCustomFields());
        }).catch(error => { throw error; })
    }
}

export function UpdatePMCustomFieldsOrder(data){
    return function(dispatch){
        return APIutil.editDataAPI(url.post_PreventativeMaintenanceCustomFields,data).then(response => {
            dispatch(global_error_handling(response));  
            if(response.status == 200)
                dispatch(GetCustomFields());
        }).catch(error => { throw error; })
    }
}

export function OpenAddCustomPopup(data,FieldId){
    return {
        type: types.ADD_CUSTOM_CLOSE_MODAL_POPUP,
        add_custom_modal_open: data,
        CustomFieldId: FieldId,
    }
}

export function OpenAddTemplatePopup(data,templateId){
    return {
        type: types.ADD_TEMPLATE_CLOSE_MODAL_POPUP,
        add_template_modal_open: data,
        templateId: templateId,
    }
}

export function  GetWorkOrderReportsDetails(ReportID){
    return function(dispatch){
        return APIutil.getDataAPI(url.get_AllWorkOrderReports+"/"+ReportID).then(response => {
            dispatch(global_error_handling(response));
            if(response!=null && response!=undefined)
                dispatch(actionToStoreSuccess(response,types.GET_WORKORDERREPORTS_DETAILS));
        }).catch(error =>{
            throw error;
        })
    }
}

export function SaveWOReport(data){
    return function (dispatch) {
        return APIutil.postData(url.post_WorkOrderReport,data).then(response => {
            dispatch(global_error_handling(response));
            if(response.status == 200){
                dispatch(GetWorkOrderReportsList());
                return(response.data.workOrderReportId);
            }
        }).catch(error => {throw error;})
    }
}

export function UpdateWOReport(data, id){
    return function (dispatch) {
        return APIutil.editDataAPI(url.post_WorkOrderReport+"/"+id,data).then(response => {
            dispatch(global_error_handling(response));  
            if(response.status == 200){
                dispatch(GetWorkOrderReportsList());
                return(response.data.workOrderReportId);
            }  
        }).catch(error => { throw error; })
    }
}

export function DeleteReports(reportId){
    return function(dispatch){
        return APIutil.deleteDataAPI(url.delete_WorkOrderReports,reportId).then(response => {
            dispatch(global_error_handling(response));
            if(response.status === 200)
                dispatch(GetWorkOrderReportsList());
        }).catch(error => {throw error});
    }
}

export function GenerateWOReportPDF(reportID,reportName){
    return function(dispatch){
        return APIutil.postDataForPDF(url.generate_WOReports_PDF,reportID).then(response => {
            var fileName = reportName, fileFormat = '.pdf';
            if(response.status === 200){
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(new Blob([response.data]),  fileName + fileFormat);
                }
                else {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', fileName + fileFormat);
                    document.body.appendChild(link);
                    link.click();
                    }
                }
        }).catch(error => {throw error});
    }
}

export function GenerateWOReportXLS(reportID, reportName){
    return function(dispatch){
        return APIutil.postDataForPDF(url.generate_WOReports_XLS,reportID).then(response => {
            var fileName = reportName, fileFormat = '.xlsx';
            if(response.status === 200){
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(new Blob([response.data]),  fileName + fileFormat);
                }
                else{
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', fileName + fileFormat);
                    document.body.appendChild(link);
                    link.click();
                } 
            }
        }).catch(error => {throw error});
    }
}

export function SavePreventativeMaintenanceTemplate(data){
    return function (dispatch) {
        return APIutil.postData(url.post_PreventativeMaintenanceTemplate,data).then(response => {
            dispatch(global_error_handling(response)); 
            if(response.status == 200)
                dispatch(GetPreventativeMaintenanceTemplates())
        }).catch(error => { throw error; })
    }
}

export function DeletePMTemplate(templateId){
    return function (dispatch){
        return APIutil.deleteAPI(url.delete_PreventativeMaintenanceTemplate + "/" + templateId).then(response => {
            dispatch(global_error_handling(response)); 
            if(response.status == 200)
            {                            
               dispatch(GetPreventativeMaintenanceTemplates());
            }
        }).catch(error => {throw error; })
    }
}

export function GetPreventativeMaintenanceTemplateDetails(templateId){
    return function (dispatch){
        return APIutil.getDataAPI(url.get_IndividualPreventativeMaintenanceTemplate + "/" + templateId).then(response => {
            dispatch(global_error_handling(response));
            if(response !== null && response !== undefined){
                dispatch(actionToStoreSuccess(response,types.GET_PM_TEMPLATE_DETAILS));
            }
        }).catch(error => {throw error;})
    }
}

export function UpdatePreventativeMaintenanceTemplate(templateId, data){
    return function(dispatch){
        return APIutil.editDataAPI(url.post_PreventativeMaintenanceTemplate + "/" + templateId, data).then(response => {
            dispatch(global_error_handling(response));
            if(response.status == 200)
                dispatch(GetPreventativeMaintenanceTemplates())
        }).catch(error => {throw error;})
    }
}

export function AddPreventativeMaintenanceTemplateAttachment(data,templateId){
    return function(dispatch){
        return APIutil.postData(url.post_PreventativeMaintenanceTemplate + "/" + templateId + "/attachment", data).then(response => {
            dispatch(global_error_handling(response));
            if(response.status == 200)
                dispatch(GetPreventativeMaintenanceTemplateDetails(templateId));
        }).catch(error => {throw error;})
    }
}

export function DeletePreventativeMaintenanceTemplateAttachment(templateId, id){
    return function(dispatch){
        return APIutil.deleteAPI(url.post_PreventativeMaintenanceTemplate + "/" + templateId + "/attachment/" + id).then(response => {
            dispatch(global_error_handling(response));
            if(response.status == 200)
                dispatch(GetPreventativeMaintenanceTemplateDetails(templateId));
        }).catch(error => {throw error;})
    }
}


export function SaveWorkOrderMailAddresses(data){
    return function (dispatch) {
        return APIutil.postData(url.post_WOSetup_MailAddress,data).then(response => {
            dispatch(global_error_handling(response)); 
            if(response.status == 200)
                dispatch(GetWorkOrderMailAddresses())
        }).catch(error => { throw error; })
    }
}

export function GetWorkOrderMailAddresses(){
    return function (dispatch){
        return APIutil.getDataAPI(url.post_WOSetup_MailAddress).then(response => {
            dispatch(global_error_handling(response));
            if(response !== null && response !== undefined){
                dispatch(actionToStoreSuccess(response,types.GET_WOSETUPMAILADDRESSES));
            }
        }).catch(error => {throw error;})
    }
}

export function SavePreventativeMaintenanceMailAddresses(data){
    return function (dispatch) {
        return APIutil.postData(url.post_PMSetup_MailAddress,data).then(response => {
            dispatch(global_error_handling(response)); 
            if(response.status == 200)
                dispatch(GetPreventativeMaintenanceMailAddresses())
        }).catch(error => { throw error; })
    }
}

export function GetPreventativeMaintenanceMailAddresses(){
    return function (dispatch){
        return APIutil.getDataAPI(url.post_PMSetup_MailAddress).then(response => {
            dispatch(global_error_handling(response));
            if(response !== null && response !== undefined){
                dispatch(actionToStoreSuccess(response,types.GET_PMSETUPMAILADDRESSES));
            }
        }).catch(error => {throw error;})
    }
}

export function SaveServiceRequestDetails(data){
    return function (dispatch) {
        return APIutil.postData(url.post_ServiceRequestSetupDetails,data).then(response => {
            dispatch(global_error_handling(response));
            if(response !== null && response !== undefined){
                dispatch(GetServiceRequestSetupDetails());
            }
        }).catch(error => { throw error; })
    }
}

export function GetServiceRequestSetupDetails(){
    return function (dispatch){
        return APIutil.getDataAPI(url.get_ServiceRequestSetupDetails).then(response => {
            dispatch(global_error_handling(response));
            if(response !== null && response !== undefined){
                dispatch(actionToStoreSuccess(response,types.GET_SERVICE_REQUEST_SETUP_DETAILS));
            }
        }).catch(error => {throw error;})
    }
}

export function GetWOFormCustomFields(){
    return function(dispatch){
        return APIutil.getDataAPI(url.get_WOForm_CustomFields).then(response => {
            dispatch(global_error_handling(response));
            if(response !== null && response !== undefined)
                dispatch(actionToStoreSuccess(response, types.GET_WOFORM_CUSTOMFIELDS));
        }).catch(error => {throw error;})
    }
}

export function GetWOFormTenantLists(){
    return function(dispatch){
        return APIutil.getDataAPI(url.get_WOForm_TenantLists).then(response => {
            dispatch(global_error_handling(response));
            if(response !== null && response !== undefined)
                dispatch(actionToStoreSuccess(response, types.GET_WOFORM_TENANTLISTS));
        }).catch(error => {throw error});
    }
}

export function actionToStoreSuccess(response,actionType){
    return{
        type : actionType,
        getResponse : response,
    }
}